module.exports = __webpack_public_path__ + "img/icon_bsite_white.a121da08.svg";